import { render } from "./LedgerCreateDefaultSettings.vue?vue&type=template&id=f805531a&scoped=true"
import script from "./LedgerCreateDefaultSettings.vue?vue&type=script&lang=js"
export * from "./LedgerCreateDefaultSettings.vue?vue&type=script&lang=js"

import "./LedgerCreateDefaultSettings.vue?vue&type=style&index=0&id=f805531a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f805531a"]])

export default __exports__